import { FC } from "react";

import { CollapsedFields } from "../../../components/GeneralUI/CollapsedFields/CollapsedFields";
import { hasNumberValue } from "../../../helpers";
import { NamedNumberic } from "../../../ui/layout/molecules/NamedNumberic";
import { netTitleToSubtitle } from "../../../helpers/titles/netTitleToSubtitle";
import {
  numericSettingsTitles,
  percentageNumberSettings,
} from "../../constants";
import { textSearchSettingsTitles } from "../../textSearch/constants";
import { CampaignNetKey, HandleCampaignChange } from "../../types";
import { TextSearchNumbericTitlesKey } from "../../textSearch/types";

const netsTitles = { ...numericSettingsTitles, ...textSearchSettingsTitles };

export type NetsKeys = CampaignNetKey | TextSearchNumbericTitlesKey;

export const RenderNumericNet: FC<{
  value?: number;
  net: NetsKeys;
  handleChange: HandleCampaignChange;
}> = ({ value, net, handleChange }) => {
  const active = hasNumberValue(value);
  const title = netsTitles[net];
  const resetFields = () => handleChange(net, true)(0);
  const onValueChange = (target: HTMLInputElement) =>
    handleChange(net, true)(target.value);
  return (
    <CollapsedFields
      title={title}
      active={active}
      resetFields={resetFields}
      key={title}
      subtitle={netTitleToSubtitle(title)}
    >
      <NamedNumberic
        title={title}
        value={value}
        onChange={onValueChange}
        {...percentageNumberSettings} //all nets are percentage based
        addSimilarity={true}
        addPercentage={true}
      />
    </CollapsedFields>
  );
};
